import React, { lazy, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useUsuario } from "./context/usuarioContext";
import Layout from "./layouts/Layout";
import {
  BOLETAS_LINK,
  INTERNET_LINK,
  MOVIL_LINK,
  MUNDO_GO_LINK,
  PAGOS_LINK,
  REAGENDAR_VISITA_LINK,
  REALIZAR_SOLICITUD_LINK,
  REGISTRO_ACTIVIDAD_LINK,
  RECLAMOS_LINK,
  SOLICITUDES_COMERCIALES_LINK,
  SOLICITUDES_TECNICAS_LINK,
  SUGERENCIAS_LINK,
  PLAN_LINK,
  BENEFICIOS_LINK,
  CONFIGURACION,
  DISPOSITIVOS,
  ACTIVAR_LINEAS,
  CAMBIO_SIM_LINK,
} from "./helpers/enlacesSideBar";
import { AYUDA_LINK, PERFIL_LINK, OFERTA_LINK } from "./helpers/enlacesNavBar";
import ReclamoMailRespuesta from "./layouts/ReclamosMailRespuesta/ReclamoMailRespuesta";
import useChatbot from "./queries/login/useChatbot";
import Dispositivos from "./modules/conexion/page/Dispositivos";
import Configuracion from "./modules/conexion/page/Configuracion";
import ActivacionLineas from "./modules/activacionLineas";
import Sim from "./modules/sim";

//NotLoged
const Login = lazy(() => import("./layouts/Login"));
const Recuperar = lazy(() =>
  import("./components/CambioPassword/CambioPasswordPage")
);
const Confirmacion = lazy(() =>
  import("./components/Confirmacion/ConfirmacionPage")
);

//Loged
const Resumen = lazy(() => import("./modules/Resumen"));
const Boletas = lazy(() => import("./modules/facturacion/pages/boletas"));
const Pagos = lazy(() => import("./modules/facturacion/pages/pagos"));
const Internet = lazy(() => import("./modules/plan/pages/internet"));
const Movil = lazy(() => import("./modules/plan/pages/movil"));
const Plan = lazy(() => import("./modules/plan/Plan"));
const Beneficios = lazy(() => import("./modules/beneficios"));
const CambioSim = lazy(() => import("./modules/sim"));

const MundoGO = lazy(() => import("./modules/mundoGo"));
const RealizarSolicitud = lazy(() =>
  import("./modules/solicitudes/pages/realizarSolicitud/RealizarSolicitud")
);
const SolicitudesComerciales = lazy(() =>
  import("./modules/solicitudes/pages/comerciales/SolicitudesComerciales")
);
const SolicitudesTecnicas = lazy(() =>
  import("./modules/solicitudes/pages/tecnicas/SolicitudesTecnicas")
);
const ReagendarVisita = lazy(() =>
  import("./modules/solicitudes/pages/reagendarVisita/ReagendarVisita")
);
const RegistroActividad = lazy(() =>
  import("./modules/solicitudes/pages/registroActividad/RegistroActividad")
);
const Reclamos = lazy(() =>
  import("./modules/solicitudes/pages/reclamos/Reclamos")
);

const Sugerencias = lazy(() => import("./modules/sugerencias"));

const Perfil = lazy(() =>
  import("./components/Navbar/Secciones/Perfil/Perfil")
);
const Oferta = lazy(() =>
  import("./components/Navbar/Secciones/Oferta/Oferta")
);
const Ayuda = lazy(() => import("./components/Navbar/Secciones/Ayuda/Ayuda"));

const RouterApp = () => {
  const { usuario } = useUsuario();

  let search = window.location.search;
  let params = new URLSearchParams(search);

  return usuario ? (
    !params.get("key") || !params.get("extencion") ? (
      <LogedInRoutes />
    ) : (
      <NotLogedRoutes />
    )
  ) : (
    <NotLogedRoutes />
  );
};

const NotLogedRoutes = () => {

  useEffect(() => {

    const scriptToRemove = document.getElementById('cari_button');
    const chatContainer = document.getElementById('cari_webchat_container');
    if (scriptToRemove && scriptToRemove.parentNode) {
      scriptToRemove.parentNode.removeChild(scriptToRemove);
    }

    if (chatContainer && chatContainer.parentNode) {
      chatContainer.parentNode.removeChild(chatContainer);
    }
  }, []);


  return (
    <>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/recuperar" element={<Recuperar />} />
        <Route exact path="/confirmacion" element={<Confirmacion />} />
        <Route path={"/reclamos-archivos"} element={<ReclamoMailRespuesta />} />
        <Route path="*" element={<Login />} /> {/* <Navigate to="/login" /> */}
      </Routes>
    </>
  );
};
const LogedInRoutes = () => {
  const { usuario } = useUsuario();
  const urlChat = useChatbot();

  useEffect(() => {
    if (urlChat.isSuccess) {
      const script = document.createElement("script");

      script.src = urlChat.data.success.descripcionRespuesta;
      script.async = true;

      document.head.appendChild(script);
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [urlChat.isSuccess]);

  useEffect(() => {
    urlChat.mutate({ rut: usuario.RutClient });
  }, []);

  return (
    <>
      <Layout>
        <Routes>
          <Route exact path="/" element={<Resumen />} />
          <Route path={BOLETAS_LINK} element={<Boletas />} />
          <Route path={PAGOS_LINK} element={<Pagos />} />
          <Route path={INTERNET_LINK} element={<Internet />} />
          <Route path={MOVIL_LINK} element={<Movil />} />
          <Route path={PLAN_LINK} element={<Plan />} />
          <Route path={MUNDO_GO_LINK} element={<MundoGO />} />
          <Route
            path={REALIZAR_SOLICITUD_LINK}
            element={<RealizarSolicitud />}
          />
          <Route
            path={SOLICITUDES_COMERCIALES_LINK}
            element={<SolicitudesComerciales />}
          />
          <Route
            path={SOLICITUDES_TECNICAS_LINK}
            element={<SolicitudesTecnicas />}
          />
          <Route path={REAGENDAR_VISITA_LINK} element={<ReagendarVisita />} />
          <Route path={SUGERENCIAS_LINK} element={<Sugerencias />} />
          <Route
            path={REGISTRO_ACTIVIDAD_LINK}
            element={<RegistroActividad />}
          />
          <Route path={RECLAMOS_LINK} element={<Reclamos />} />

          <Route path={PERFIL_LINK} element={<Perfil />} />
          <Route path={OFERTA_LINK} element={<Oferta />} />
          <Route path={AYUDA_LINK} element={<Ayuda />} />

          <Route path={BENEFICIOS_LINK} element={<Beneficios />} />

          <Route path={CONFIGURACION} element={<Configuracion />} />
          <Route path={DISPOSITIVOS} element={<Dispositivos />} />
          <Route path={ACTIVAR_LINEAS} element={<ActivacionLineas />} />

          <Route path={CAMBIO_SIM_LINK} element={<Sim />} />

          <Route path="*" element={<Resumen />} />
        </Routes>
      </Layout>
    </>
  );
};
export default RouterApp;
